<template>
  <div class="info">
    <template v-if="titleList">
      <div class="card-wrapper">
        <div class="content">
          <div class="row">
            <div class="col-4 no-padding">
              <div class="row">
                <div class="column col-xs-3 q-pr-md">
                  Product:
                </div>
                <div class="col-xs-6 q-pl-md trim text-right self-center">
                  <router-link
                    :to="{
                      name: 'product',
                      params: { id: titleList.product.id }
                    }"
                    class="lm-link block lm-link--tertiary text-right trim"
                  >
                    <span>{{ titleList.product.name }}</span>
                  </router-link>
                </div>
              </div>
              <div class="row">
                <div class="column col-xs-3 q-pr-md trim">
                  Platform
                </div>
                <div class="col-xs-6 q-pl-md trim text-right">
                  {{ titleList.product.platform }}
                </div>
              </div>
              <div class="row">
                <div class="column col-xs-3 q-pr-md trim">
                  Valid from:
                </div>
                <div class="col-xs-6 q-pl-md text-right">
                  <entity-editor
                    :params="titleList"
                    :options="null"
                    :value="titleList.valid_from"
                    title="Valid from"
                    type="date"
                    size="big"
                    position="right"
                    class="title-list-date"
                    @update="saveEdit({ valid_from: $event }, true, 'valid_from')"
                  >
                    <template v-if="titleList.valid_from" slot="content">
                      <span class="font-sm">
                        {{
                          titleList.valid_from ? formatDateForCustomDisplay(titleList.valid_from, 'D MMM. Y') : 'N/A'
                        }}
                      </span>
                    </template>
                  </entity-editor>
                </div>
              </div>
              <div class="row">
                <div class="column col-xs-3 q-pr-md">
                  Valid to:
                </div>
                <div class="col-xs-6 q-pl-md text-right">
                  <entity-editor
                    :params="titleList"
                    :options="null"
                    :value="titleList.valid_to"
                    :dependency="titleList.valid_from"
                    title="Valid to"
                    type="date"
                    size="big"
                    position="right"
                    class="title-list-date"
                    @update="saveEdit({ valid_to: $event }, true, 'valid_to')"
                  >
                    <template v-if="titleList.valid_to" slot="content">
                      <span class="font-sm">
                        {{ titleList.valid_to ? formatDateForCustomDisplay(titleList.valid_to, 'D MMM. Y') : 'N/A' }}
                      </span>
                    </template>
                  </entity-editor>
                </div>
              </div>
            </div>
            <div class="col-8 text-right">
              <div class="row items-end justify-end q-mb-sm">
                <q-btn round size="7px" icon="fas fa-cog" class="text-white" style="background: #1b4a6c">
                  <q-menu fit anchor="bottom middle" self="top right">
                    <q-list style="min-width: 150px;">
                      <q-item
                        v-for="(action, key) in topBarActions"
                        :key="key"
                        v-close-popup
                        :disable="action.disabled"
                        :class="action.textClass"
                        clickable
                        @click="performAction(action)"
                      >
                        <q-item-section>
                          <q-item-label>{{ action.name }}</q-item-label>
                          <q-item-label caption>{{ action.description }}</q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-menu>
                </q-btn>
              </div>

              <h3 class="text-tertiary">{{ titleList.publications_count }}</h3>
              <span class="font-sm">{{ titleList.publications_count === 1 ? 'Publication' : 'Publications' }}</span>
            </div>
          </div>
        </div>
      </div>
      <template v-for="action in topBarActions">
        <lm-dialog
          v-if="action.dialogUid"
          :key="action.uid"
          :uid="action.dialogUid"
          :entity="titleList"
          :callback="redirectToIndex"
          store-namespace="titleLists"
        />
      </template>
    </template>
    <SpinnerAudioLoader v-else :loading="true" />
  </div>
</template>

<script>
import { uid } from 'quasar'
import { mapState, mapActions } from 'vuex'
// Components
import EntityEditor from '@components/editors/EntityEditor'
import LmDialog from '@components/lm-blocks/Dialog'
import SpinnerAudioLoader from '@/reusable/base-components/SpinnerAudioLoader'

export default {
  name: 'LmTitleListInfo',
  components: {
    EntityEditor,
    LmDialog,
    SpinnerAudioLoader
  },

  data() {
    return {
      topBarActions: {
        delete: {
          name: 'Delete',
          type: 'delete',
          action: 'titleLists/deleteConfirmation',
          id: null,
          dialogUid: uid(),
          textClass: 'text-negative'
        }
      }
    }
  },

  computed: {
    ...mapState('title-list-show', ['titleList']),

    selectStatus() {
      let active = []
      active.push({ value: 1, label: 'Active' })
      active.push({ value: 0, label: 'Inactive' })

      return active
    }
  },

  watch: {
    titleList(val) {
      if (!val) return
      this.topBarActions.delete.id = val.id
    }
  },

  methods: {
    ...mapActions('title-list-show', ['updateTitleList']),

    saveEdit(event, asDate = false, dateProp) {
      let payload = event
      if (asDate) {
        payload[dateProp] = this.formatDateForPost(event[dateProp])
      }
      this.updateTitleList({ id: this.titleList.id, payload })
    },
    redirectToIndex() {
      this.$router.back()
    },
    performAction(params) {
      this.$store.dispatch(params.action, params)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/stylus/variables.styl'

.info {
  position relative
  width: 100%
  height 100%
  font-size 12px
  .header {
    display grid
    grid-template-columns 50% auto
    justify-content space-between
    align-items center
    .header-title {
      width 100%
      font-size 18px
      font-weight 500
      color #00
    }
    .actions {
      display grid
      grid-auto-flow column
      grid-gap 10px
      align-items center
    }
    >>> .editable-content .editable-content__text {
      max-width 100%
    }
  }
  .content {
    width: 100%
    line-height: 28px;
    >>> .editable-content .editable-content__text {
      max-width 100%
      width 100%
    }
  }
}
</style>
